import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';

interface TabNavigationProps {
	options: { label: string; path: string }[];
}

const TabNavigation = ({ options }: TabNavigationProps) => {
	const location = useLocation();
	return (
		<ul
			className={classNames(
				'grid grid-cols-1 sm:grid-cols-2 lg:grid-flow-col lg:auto-cols-fr rounded-t-lg overflow-hidden bg-white',
				{
					'md:grid-cols-3': options.length > 2,
				}
			)}
		>
			{options.map(({ label, path }) => {
				const isActive = path === location.pathname;

				return (
					<li key={path}>
						<Link
							to={path}
							className={classNames(
								'grid text-center py-2 text-primary hover:bg-primary-lighter transition-colors',
								{
									'border-b-[3px] border-primary-light font-bold':
										isActive,
								}
							)}
							aria-current={isActive ? 'page' : undefined}
						>
							{label}
						</Link>
					</li>
				);
			})}
		</ul>
	);
};

export default TabNavigation;
